// Purpose is to provide data for all dashboards
//import linq from 'linq';
import Enumerable from 'linq';

const getAllinvoices = (projects) => {
	let invoices = Enumerable.from(projects).select(p => p.invoices);
	let invoicesArray = invoices.toArray();
	let items = invoicesArray.map(inv => Object.values(inv)).flat();
	return Enumerable.from(items);
};

const getTurnoverMonth = (projects) => {


	// first get all invoices of all projects
	var projects = getAllinvoices(projects).toArray();

	// filter only ones that are paid
	var invoicesPaid = projects.filter(i => i.datePaid);

	// var teams = Enumerable.From(employees)
	//   .GroupBy(
	//       "employee => employee.role", 
	//       "employee => { name: employee.firstName + ' ' + employee.lastName }", 
	//       "key, grouping => { team: key, members: grouping.source }"
	//   )
	// 	.ToArray();


	const reducer = (acc, item) => acc += Number(item.amount);
	var total = invoicesPaid.reduce(reducer, 0);

	//return total;

	// return a dummy set of data we would like to get!


};

export const getDashboardInfo = (state, mode) => {
	if (mode == "turnover_month")
		return getTurnoverMonth(state.projects);
	else
		return [];
};
